import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const GameHeader = ({ 
  difficulty, 
  onDifficultyChange, 
  lives, 
  difficultyNames, 
  isMobile 
}) => {
  const { t } = useLanguage();

  return (
    <div className="game-header">
      <div className="difficulty-selector">
        <span className="difficulty-label">{t('difficulty')}</span>
        <select 
          value={difficulty}
          onChange={(e) => onDifficultyChange(Number(e.target.value))}
          className="difficulty-dropdown"
        >
          {Object.entries(difficultyNames).map(([level, name]) => (
            <option key={level} value={level}>
              {isMobile ? level : t(`difficultyLevels.${level}`)}
            </option>
          ))}
        </select>
        <span className="lives-label">{t('lives')}</span>
        <div className="lives">
          {[...Array(5)].map((_, i) => (
            <span key={i} className="heart">
              {i < lives ? '❤️' : '🤍'}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GameHeader; 